function formatClockTime(second, startTime = '2000-01-01T00:00:00.000Z') {
    const baseTime = new Date(startTime)
    const newTime = new Date(baseTime.getTime() + second * 1000)

    // 回傳台灣時間 (24小時制)
    return newTime.toLocaleTimeString('zh-TW', { hour12: false })
}

export default formatClockTime;